import tokens from '@kluein/design-tokens';
import { Box, Text } from '@kluein/klue-ui';
import { EyeSlash, Info, ThumbsUp } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledText = styled(Text)`
  color: ${tokens.color.neutral[900]};
`;

function WhatIsKlueAI() {
  const { t } = useTranslation(['Dashboard']);

  return (
    <Box
      pad="medium"
      elevation="xsmall"
      background={tokens.color.neutral.white.main}
      round="xsmall"
      justify="center"
      height="100%"
    >
      <Box direction="row" gap="xsmall" align="center">
        <Text color={tokens.color.neutral.black.main} fontWeight="semibold">
          {t('Dashboard:askKlue.whatIsKlueAI.questionTitle')}
        </Text>
      </Box>
      <Box gap="medium" pad="small">
        <Box direction="row" align="center" gap="xsmall">
          <EyeSlash size={tokens.iconSize.small} />
          <StyledText>
            {t('Dashboard:askKlue.whatIsKlueAI.answer.first')}
          </StyledText>
        </Box>
        <Box direction="row" align="center" gap="xsmall">
          <Info size={tokens.iconSize.small} />
          <StyledText>
            {t('Dashboard:askKlue.whatIsKlueAI.answer.second')}
          </StyledText>
        </Box>
        <Box direction="row" align="center" gap="xsmall">
          <ThumbsUp size={tokens.iconSize.small} />
          <StyledText>
            {t('Dashboard:askKlue.whatIsKlueAI.answer.third')}
          </StyledText>
        </Box>
      </Box>
    </Box>
  );
}

export default WhatIsKlueAI;
